import { useEffect } from 'react';
import { PACKAGES_SECTION_ID } from '~/constants/new-cars/sectionIds';
import type { AutoSelectConfirm } from '~/contracts/new-cars';
import AutoSelectModal from './AutoSelectModal';

type OwnProps = {
  confirm: AutoSelectConfirm | null;
  onCancel: () => void;
  onContinue: () => void;
};

export default function AutoSelectModalWrapper({
  confirm,
  onCancel,
  onContinue
}: OwnProps) {
  useEffect(() => {
    if (confirm?.trigger?.key !== 'package') return;

    const id = requestAnimationFrame(() => {
      document
        .getElementById(PACKAGES_SECTION_ID)
        ?.scrollIntoView({ behavior: 'smooth' });
    });

    return () => cancelAnimationFrame(id);
  }, [confirm]);

  if (!confirm) return null;

  return (
    <AutoSelectModal
      confirm={confirm}
      isOpen
      onCancel={onCancel}
      onContinue={onContinue}
    />
  );
}
